var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgArrowLeftLong = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.42188 6.45703L7.42188 0.45703C7.98438 -0.152345 8.96875 -0.152345 9.53125 0.45703C10.1406 1.01953 10.1406 2.0039 9.53125 2.5664L6.10938 5.98828L23.5 5.98828C24.2969 5.98828 25 6.69141 25 7.48828C25 8.33203 24.2969 8.98828 23.5 8.98828L6.10938 8.98828L9.53125 12.457C10.1406 13.0195 10.1406 14.0039 9.53125 14.5664C8.96875 15.1758 7.98437 15.1758 7.42188 14.5664L1.42188 8.5664C0.812501 8.0039 0.812501 7.01953 1.42188 6.45703Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowLeftLong, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-left-long.9e150fe6.svg";
export { ForwardRef as ReactComponent };